import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const Primarywing = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },

    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/learning-app.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Primary Wing"
                breadEnd="Learning Approach"
                breadMid="Primary Wing"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <h5 className="text-center color-green mb-4">
                <i>
                  Every child is gifted, they just unwrap their packages at
                  different times
                </i>
              </h5>
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/primary1.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                At <strong>Lotus Valley International School, Gurgaon </strong>{" "}
                we believe in enabling children to realize their own potential
                to excellence and to nurture their young minds through knowledge
                and exposure. The Primary wing opens its arms to the little
                learners who walk into our world with expectations and desires.
                It is our endeavor to facilitate them to develop as social
                beings by guiding them to interact and cooperate with each
                other.
              </p>
              <p>
                Our Curriculum incorporates current Educational thinking and the
                most effective pedagogical practices. It represents a process of
                revision that is both evolutionary and developmental. We firmly
                believe in taking children out of the classroom spaces to
                experience the real world through varied experiments and hand-on
                activities. Our aim is to foster the child in all dimensions of
                his or her life—{" "}
                <strong>
                  moral, spiritual, cognitive, emotional, imaginative,
                  aesthetic, social and physical.{" "}
                </strong>{" "}
                In order to realize this view of the child and education, our
                curriculum outlines a detailed and structured framework of
                content that is comprehensive and flexible. It promotes the
                active involvement of children in a learning process that is
                imaginative and stimulating. The ability to think critically, to
                apply learning and to develop flexibility and creativity are
                also important factors in the success of the child’s life.
              </p>
            </div>

            <div className="col-xl-12 mb-4">
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/primary2.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                Various activities are designed round the year keeping in view
                the wholesome development of children in mind. Field trips,
                Training workshops & excursions are planned in tandem with the
                curriculum; <strong> International Days </strong> are celebrated
                to expose the learners to wide cultural diversity that broadens
                their horizon. The school focuses on taking learning to another
                level through the celebration of subjects over weeks such as
                -Literary, Technomathematik, Eloquence week etc. which gives an
                impetus to children’s logical and creative thinking.{" "}
                <strong>Reading books </strong> aloud to children stimulates
                their imagination and expands their understanding of the world
                besides developing their language and listening skills.
              </p>
            </div>
            <div className="col-xl-12 mb-4">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/primary3.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                The extensive Reading Programme from Pre Primary to Grade – III
                demands the involvement of learners, parents and mentors on a
                common platform. This not only strengthens the bond between the
                three, but also enhances the learner’s vocabulary with developed
                interest for reading. <strong> Class Assemblies </strong> are
                another important feature of our School life. They act as a
                medium to reflect our positive school ethos and value based
                education through student’s participation and achievements. Our
                School also follows a Value based ‘Mogly Gurukul’ Programme with
                an aim to inculcate values into our young learners at the
                earliest stages of life. Fitkid is yet another successful
                programme that helps the learners in identifying pros and cons
                of good health, nutrition, safety and hygiene.{" "}
                <strong>
                  {" "}
                  Therefore, an important goal of our curriculum is to enable
                  children to learn how to learn and to develop an appreciation
                  of the value and practice of lifelong learning.{" "}
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Primarywing;
